var _rect, _line, _polyline, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingApartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 216,
    x2: 240,
    y2: 216,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "224 216 224 72 176 72 176 40 80 40 80 104 32 104 32 216",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 72,
    x2: 136,
    y2: 72,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 104,
    x2: 136,
    y2: 104,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 176,
    y1: 104,
    x2: 192,
    y2: 104,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 136,
    x2: 80,
    y2: 136,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 168,
    x2: 80,
    y2: 168,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 136,
    x2: 136,
    y2: 136,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 176,
    y1: 136,
    x2: 192,
    y2: 136,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 176,
    y1: 168,
    x2: 192,
    y2: 168,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "112 216 112 168 144 168 144 216",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingApartment);
export default __webpack_public_path__ + "static/media/building-apartment.0355714802867b384228689bdba1eb49.svg";
export { ForwardRef as ReactComponent };